// src/features/dashboard/components/EmployeeIdleTime/IdleDailyTable.tsx

import { IdleDailyDetailResponse } from '../../types/Employee/employeeIdleTime.types';

interface Props {
  data?: IdleDailyDetailResponse;
  loading?: boolean;
}

const IdleDailyTable = ({
  data,
  loading,
}: Props) => {
  if (loading) {
    return (
      <div className="h-[310px] animate-pulse rounded-[18px] bg-gray-200" />
    );
  }

  const rows = data?.details ?? [];
  const wtdRow = data?.summary;

  return (
    <div
      className="
        rounded-[18px]
        border
        border-[#D0D5DD]
        bg-white
        px-5
        pt-4
        pb-5
      "
    >
      {/* Header */}
      <div className="mb-3 flex items-center gap-3">
        <h3
          className="
            text-[15px]
            font-semibold
            text-[#002B5B]
          "
        >
          Daily Idle Detail · This Week
        </h3>

        <div
          className="
            rounded-full
            bg-[#EEF4FF]
            px-4
            py-[5px]
            text-[12px]
            text-[#2563EB]
          "
        >
          Idle time, reason, idle %, peak spike and team comparison
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse">

          {/* Header */}
          <thead>
            <tr className="border-b border-[#D0D5DD]">

              <th className="px-3 py-2 text-left text-[12px] font-semibold text-[#101828]">
                Day
              </th>

              <th className="px-3 py-2 text-left text-[12px] font-semibold text-[#101828]">
                Idle Time
              </th>

              <th className="px-3 py-2 text-left text-[12px] font-semibold text-[#101828]">
                Idle %
              </th>

              <th className="px-3 py-2 text-left text-[12px] font-semibold text-[#101828]">
                Peak Spike
              </th>

              <th className="px-3 py-2 text-left text-[12px] font-semibold text-[#101828]">
                vs Team Avg
              </th>

            </tr>
          </thead>

          {/* Body */}
          <tbody>
            {rows.map((row, index) => {
              const isSelected =
                row.dayLabel
                  .toLowerCase()
                  .includes('mon 04') ||
                row.dayLabel
                  .toLowerCase()
                  .includes('today');

              return (
                <tr
                  key={index}
                  className={`
                    border-b
                    border-[#EAECF0]
                    text-[12px]
                    ${
                      isSelected
                        ? 'bg-[#C7D7F2]'
                        : 'hover:bg-[#F8FAFC]'
                    }
                  `}
                >
                  {/* Day */}
                  <td
                    className="
                      px-3
                      py-[6px]
                      font-medium
                      text-[#101828]
                    "
                  >
                    {row.dayLabel}
                  </td>

                  {/* Idle Time */}
                  <td
                    className={`
                      px-3
                      py-[6px]
                      ${
                        isSelected
                          ? 'font-semibold'
                          : ''
                      }
                    `}
                  >
                    {row.idleTime}
                  </td>

                  {/* Idle Percentage */}
                  <td
                    className={`
                      px-3
                      py-[6px]
                      ${
                        isSelected
                          ? 'font-semibold'
                          : ''
                      }
                    `}
                  >
                    {row.idlePercentage}%
                  </td>

                  {/* Peak Spike */}
                  <td
                    className={`
                      px-3
                      py-[6px]
                      ${
                        isSelected
                          ? 'font-semibold'
                          : ''
                      }
                    `}
                  >
                    {row.largestSpikeMinutes} min
                  </td>

                  {/* vs Team Average */}
                  <td
                    className={`
                      px-3
                      py-[6px]
                      font-medium
                      ${
                        row.vsTeamAverage < 0
                          ? 'text-[#067647]'
                          : row.vsTeamAverage > 0
                          ? 'text-[#DC2626]'
                          : 'text-[#344054]'
                      }
                    `}
                  >
                    {row.vsTeamAverage > 0
                      ? '+'
                      : ''}
                    {row.vsTeamAverage}%
                  </td>
                </tr>
              );
            })}

            {/* WTD Average */}
            {wtdRow && (
              <tr
                className="
                  border-t
                  border-[#D0D5DD]
                  text-[12px]
                  font-semibold
                "
              >
                {/* Day */}
                <td className="px-3 py-[8px] text-[#101828]">
                  WTD Average
                </td>

                {/* Total Idle Time */}
                <td className="px-3 py-[8px] text-[#101828]">
                  {wtdRow.totalIdleTime}
                </td>

                {/* Average Idle % */}
                <td className="px-3 py-[8px] text-[#101828]">
                  {wtdRow.averageIdlePercentage}%
                </td>

                {/* Largest Week Spike */}
                <td className="px-3 py-[8px] text-[#101828]">
                  {wtdRow.largestWeekSpikeMinutes} min
                </td>

                {/* Team Average Variance */}
                <td
                  className={`
                    px-3
                    py-[8px]
                    ${
                      wtdRow.teamAverageVariance < 0
                        ? 'text-[#067647]'
                        : wtdRow.teamAverageVariance > 0
                        ? 'text-[#DC2626]'
                        : 'text-[#344054]'
                    }
                  `}
                >
                  {wtdRow.teamAverageVariance > 0
                    ? '+'
                    : ''}
                  {wtdRow.teamAverageVariance}%
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>
    </div>
  );
};

export default IdleDailyTable;